<template>
  <div class="w-full p-3" v-if="property">
    <div class="flex items-center justify-between w-full">
      <p class="text-sm text-gray-600">{{ property.property_type.name }}</p>
      <p
        class="text-[10px] font-medium text-yellow-600"
        v-if="isActivelySponsoredProperty"
      >
        SPONSORED
      </p>
    </div>
    <div class="flex items-center justify-between w-full mt-2">
      <p class="flex text-xl font-semibold text-gray-900">
        {{ formattedAmount(Number(property.price), 2) }}
        <span v-if="property.rent_payment_frequency"
          >/{{ property.rent_payment_frequency }}</span
        >
      </p>
      <img
        v-if="property.company"
        :src="property.company.photo"
        class="w-16 h-10 rounded-sm"
        alt=""
      />
    </div>
    <p class="text-gray-700 lowercase text-start">{{ property.title }}</p>
    <p class="flex items-center mt-10">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
        />
      </svg>
      <span class="text-sm">{{ property.address }}</span>
    </p>
    <div class="flex flex-row mt-2 space-x-1">
      <div class="flex items-center space-x-2">
        <BedSvg color="black" height="5" width="5" />
        <p class="text-sm">{{ property.number_of_beds }}</p>
        <div
          class="flex items-center justify-center h-4 mt-1 border-r border-gray-300"
        ></div>
      </div>
      <div class="flex items-center space-x-2">
        <BathSvg color="black" height="5" width="5" />
        <p class="text-sm">{{ property.number_of_baths }}</p>
        <div
          class="flex items-center justify-center h-4 mt-1 border-r border-gray-300"
        ></div>
      </div>
      <div class="flex items-center space-x-2">
        <PropertySizeSvg color="black" height="4" width="4" />
        <p class="text-sm">{{ property.property_size }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import BedSvg from "@/components/svg/BedSvg.vue";
import BathSvg from "@/components/svg/BathSvg.vue";
import PropertySizeSvg from "@/components/svg/PropertySizeSvg.vue";

const props = defineProps({
  property: {
    type: Object,
    required: true,
  },
});

const isActivelySponsoredProperty = computed(() => {
  if (!props.property || props.property.is_sponsored != 1) {
    return false;
  }
  const now = new Date();

  const startDate = props.property.sponsorship_start_date
    ? new Date(props.property.sponsorship_start_date)
    : null;
  const endDate = props.property.sponsorship_end_date
    ? new Date(props.property.sponsorship_end_date)
    : null;

  if (!startDate || !endDate) {
    return false;
  }

  const isActive = now >= startDate && now <= endDate;

  return isActive;
});

// Watch computed property to ensure it's being evaluated
// watchEffect(() => {
//   console.log(
//     "Computed isActivelySponsoredProperty:",
//     isActivelySponsoredProperty.value
//   );
// });
</script>
